
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {}
    } // options
  },
  data: function() {
    return {
      maxVal: 0,
      minVal: 0,
      median: 0,
      mode: 'actualValue',
      loading: true,
      formattedValuesList: [],
      floor: '',
      series: [],
      chartOptions: {
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: true,
            colorScale: {
              min: '#3e7cd21a',
              max: '#3e7cd2'
            }
          }
        },
        chart: {
          height: 350,
          type: 'heatmap',
          toolbar: {
            show: true,
            tools: {
              download: '<i class="fas fa-download"></i>'
            }
          }
        },
        dataLabels: {
          // enabled: true
          background: {
            enabled: true,
            foreColor: '#ff3046'
          },
          style: {
            fontSize: '14px',
            colors: ['#000000']
          }
        },
        xaxis: {
          type: 'category',
          categories: []
        },
        colors: ['#3e7cd2'],
        title: {},
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            return `
                  <q-card class="flex column q-pa-md">
            <div class="tool-tip-yaxis">${
              w.globals.labels[dataPointIndex]
            }</div>
                     <div class="flex items-center">
                       <div class="day-label-tool-tip">${
                         w.globals.seriesNames[seriesIndex]
                       }:</div>
                     <label class="text-bold">  ${
                       this.formattedValuesList[seriesIndex]
                         ? this.formattedValuesList[seriesIndex][dataPointIndex]
                         : 0
                     }</label></div>
                </q-card>
            `;
          }
        },
        responsive: [
          {
            breakpoint: 426,
            options: {
              dataLabels: {
                enabled: false
              }
            }
          }
        ]
      }
    };
  },

  computed: {
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared'
    ]), // mapGetters
    ...mapState('queue', ['powerHourFloor', 'posID', 'floorID', 'storeID']),
    valueRanges() {
      let intMax = parseFloat(this.maxVal);
      let intMin = parseFloat(this.minVal);
      let dv = intMax - intMin;
      return [
        intMin,
        parseInt((dv * 0.1).toFixed(1) + intMin),
        parseInt((dv * 0.2).toFixed(1) + intMin),
        parseInt((dv * 0.3).toFixed(1) + intMin),
        parseInt((dv * 0.4).toFixed(1) + intMin),
        parseInt((dv * 0.5).toFixed(1) + intMin),
        parseInt((dv * 0.6).toFixed(1) + intMin),
        parseInt((dv * 0.7).toFixed(1) + intMin),
        parseInt((dv * 0.8).toFixed(1) + intMin),
        parseInt((dv * 0.9).toFixed(1) + intMin),
        intMax
      ];
    }
  }, // computed
  watch: {
    async mode() {
      this.loading = true;
      this.loadData();
    },
    async posID() {
      await this.loadData();
    },
    async powerHourFloor() {
      await this.populateHeadMap();
      this.loading = false;
    }
  },
  created: async function() {
    this.chartOptions.chart.toolbar = {
      ...this.chartOptions.chart.toolbar,
      export: {
        svg: {
          filename: `${this.$t('BoxTrafficPowerHourByFloor.title')} ${this.$t(
            'KpiAnalysis.selected'
          )}꞉ ${this.getStartingPeriod}˷${this.getEndingPeriod}  ${this.$t(
            'KpiAnalysis.compared'
          )}꞉ ${this.getStartingCompared}˷${this.getEndingCompared}`
        },
        png: {
          filename: `${this.$t('BoxTrafficPowerHourByFloor.title')} ${this.$t(
            'KpiAnalysis.selected'
          )}꞉ ${this.getStartingPeriod}˷${this.getEndingPeriod}  ${this.$t(
            'KpiAnalysis.compared'
          )}꞉ ${this.getStartingCompared}˷${this.getEndingCompared}`
        },
        csv: {
          filename: `${this.$t('BoxTrafficPowerHourByFloor.title')} ${this.$t(
            'KpiAnalysis.selected'
          )}꞉ ${this.getStartingPeriod}˷${this.getEndingPeriod}  ${this.$t(
            'KpiAnalysis.compared'
          )}꞉ ${this.getStartingCompared}˷${this.getEndingCompared}`
        }
      }
    };

    if (this.posID) {
      await this.loadData();
    }
  }, //created
  methods: {
    ...mapActions('queue', ['fetchPowerHourDataFloor']),
    populateHeadMap: function() {
      this.series = [];
      if (
        this.powerHourFloor &&
        Object.values(this.powerHourFloor).length > 0
      ) {
        let dataList = [];

        this.series = Object.values(this.powerHourFloor)
          .map((val, key) => {
            dataList = [...dataList, ...Object.values(val).map(v => v.value)];
            return {
              name: Object.keys(this.powerHourFloor)[key],
              data: Object.values(val).map(v => v.value),
              formattedValue: val.map(dat => dat.formattedValue)
            };
          })
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

        this.maxVal = parseInt(Math.max(...dataList)).toFixed(0);
        this.minVal = parseInt(Math.min(...dataList)).toFixed(0);
        this.median = (
          (parseInt(this.maxVal) + parseInt(this.minVal)) /
          2
        ).toFixed(0);

        this.formattedValuesList = [];
        this.series.map(v => {
          this.formattedValuesList = [
            ...this.formattedValuesList,
            v.formattedValue
          ];
        });

        this.chartOptions = {
          chart: {
            height: 350,
            type: 'heatmap',
            toolbar: {
              show: true,
              tools: {
                download: '<i class="fas fa-download"></i>'
              }
            }
          },
          plotOptions: {
            heatmap: {
              enableShades: false,
              shadesIntensity: 0,
              colorScale: {
                ranges: [
                  {
                    from: this.valueRanges[0],
                    to: this.valueRanges[1],
                    color: '#ebf2fa',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[1],
                    to: this.valueRanges[2],
                    color: '#d8e5f6',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[2],
                    to: this.valueRanges[3],
                    color: '#c5d7f1',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[3],
                    to: this.valueRanges[4],
                    color: '#b2cbed',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[4],
                    to: this.valueRanges[5],
                    color: '#9ebde8',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[5],
                    to: this.valueRanges[6],
                    color: '#8bb0e4',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[6],
                    to: this.valueRanges[7],
                    color: '#78a3df',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[7],
                    to: this.valueRanges[8],
                    color: '#6596db',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[8],
                    to: this.valueRanges[9],
                    color: '#5189d6',
                    name: undefined
                  },
                  {
                    from: this.valueRanges[9],
                    to: this.valueRanges[10],
                    color: '#3e7cd2',
                    name: undefined
                  }
                ]
              }
            }
          },
          tooltip: {
            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              return `
                  <q-card class="flex column q-pa-md">
            <div class="tool-tip-yaxis">${
              w.globals.labels[dataPointIndex]
            }</div>
                     <div class="flex items-center">
                       <div class="floor-label-tool-tip">${
                         w.globals.seriesNames[seriesIndex]
                       } :</div>
                     <label class="text-bold">  ${
                       this.formattedValuesList[seriesIndex]
                         ? this.formattedValuesList[seriesIndex][dataPointIndex]
                         : 0
                     }</label></div>
                </q-card>
            `;
            }
          },
          legend: {
            show: false
          },
          dataLabels: {
            // enabled: true
            background: {
              enabled: true,
              foreColor: '#ff3046'
            },
            style: {
              fontSize: '14px',
              colors: ['#000000']
            },
            formatter: (val, series) => {
              return this.formattedValuesList[series.seriesIndex][
                series.dataPointIndex
              ];
            }
          },
          xaxis: {
            type: 'category',
            categories: Object.values(this.powerHourFloor)[0].map(v => v.hour)
          },
          colors: ['#3e7cd2'],
          title: {},
          responsive: [
            {
              breakpoint: 426,
              options: {
                dataLabels: {
                  enabled: false
                }
              }
            }
          ]
        };
      }
      this.loading = false;
    },
    async loadData() {
      this.loading = true;
      await this.fetchPowerHourDataFloor({
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        kpis: 'all',
        posID: this.posID,
        floorID: this.floorID,
        daysOfWeek: this.getDaysOfWeekList,
        storeCodes: this.storeID,
        type: this.mode
      });
    }
  }
};
